import { createContext } from 'react';
export const initialFormContext = {
    forceValidateFlag: null,
    formOnlyErrors: [],
    isEdit: false,
    isFocused: false,
    isParentEdit: false,
    isTouched: false,
    isValid: false,
    isValidating: false,
    localEdit: false,
    methods: {
        blurParent: () => {
        },
        cancel: () => {
        },
        edit: () => {
        },
        focusParent: () => {
        },
        forceValidate: () => {
        },
        getFieldId: () => '',
        removeFromForm: () => {
        },
        reset: () => {
        },
        save: () => {
        },
        setInForm: () => {
        },
        touchParent: () => {
        },
    },
    state: {},
};
export const FormContextInstance = createContext(initialFormContext);
FormContextInstance.displayName = 'FormContext';
